<template>
  <div class="container">
    <div class="row  text-right">
      <div class="col-12">
        <div class="list-btn">
          <base-button class="primary btn_create" @click="ShowModalImport">Importar</base-button>
          <base-button class="primary btn_create" @click="ShowModalExport">Exportar</base-button>
          <base-button class="primary btn_create" @click="ShowModal">Crear Producto</base-button>
        </div>
        <create-product/>
        <EditProduct/>
      </div>
    </div>
    <div class="row">
      <stats-card type="gradient-red"
                  sub-title=""
                  class="col-md-6 col-lg-6 col-sm-12"
                  v-for="(product, index) in products" :key="product.product_id"
                  :title="product.name">
        <template slot="footer">
          <div class="row">
            <div class="col-6">
              <div v-if="products[index]['Sku'].length > 0">
                <ul v-for="sku in products[index]['Sku']"
                    :key="sku.id" v-show="sku.deletedAt===null">
                  <li>
                    <strong>Sku:</strong>
                    {{ sku.sku }}
                  </li>
                  <li>Descripcion: {{ sku.description }}</li>
                  <li> Precio: {{ sku.price }}</li>
                </ul>
              </div>
              <ul>
                <li v-if="product.Category">
                  <strong>Categoria: </strong>{{ product.Category.category }}
                </li>
                <li v-if="product.ProductType">
                  <strong>Tipo de producto: </strong>{{ product.ProductType.type_name }} <br>
                </li>
              </ul>
            </div>
            <div class="col-6">
              <div v-if="products[index]['Sku'].length > 0">
                <carousel :per-page="1" :mouse-drag="false">
                  <slide v-if="getimg(products[index]['Sku'])">
                    <img :src="full_url_img+getimg(products[index]['Sku'])" alt=""
                         class="img-produt">
                  </slide>

                  <slide v-else>
                    <img src="../../../public/img/IMAGES/default.png"
                         class="img-produt" alt="">
                  </slide>
                </carousel>
              </div>
              <div v-else>
                <carousel :per-page="1" :mouse-drag="false">
                  <slide>
                    <img src="../../../public/img/IMAGES/default.png"
                         class="img-produt" alt="">
                  </slide>
                </carousel>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-right">
              <base-button @click="ShowModalEdit(product.product_id)" size="sm" outline type="default">
                Editar
              </base-button>
              <base-button @click="DeleteProduct(product.product_id)" size="sm" outline type="danger">
                Eliminar
              </base-button>
            </div>
          </div>
          <span class="text-nowrap">    </span>
        </template>
      </stats-card>
    </div>
    <div v-if="products.length === 0">No hay productos para mostrar</div>
    <base-pagination align="center" v-model="value" :page-count="page_count"></base-pagination>
    <import-product/>
  </div>
</template>

<script>
import {bus} from './bus-product'
import CreateProduct from "./CreateProduct";
import EditProduct from "./EditProduct";
import {CONSTANTS_PROD, CONSTANTS_TEST, TEST_ENVIRONMENT} from '../../config/constants'
import swal from 'sweetalert';
import {product_service} from "../../services/product/ProductService";
import ImportProduct from "./ImportProduct"

export default {
  name: "ShowProduct",
  components: {EditProduct, CreateProduct, ImportProduct},
  data() {
    return {
      products: {},
      constants: {},
      full_url_img: '',
      full_url_img2: '',
      page_count: 0,
      value: 1

    }
  },
  watch: {
    'value': function () {
      product_service.GetAllProductPagination((this.value * 10) - 10)
    }
  },
  methods: {
    getdata() {
      product_service.GetAllProduct()
    },
    getimg(arr) {

      if (arr[0].Skuid.length > 0) {
        const arr_img = arr[0].Skuid
        for (const img in arr_img) {
          return arr_img[img].img_url
        }
      }

    },
    parsearr(arr) {
      return JSON.parse(arr)
    },
    ShowModal() {
      bus.ShowProduct()
    },
    ShowModalEdit(id) {
      bus.ShowProductEdit(id)
    },
    ShowModalImport() {
      document.getElementsByClassName('container-import')[0].style.display = 'block';
    },
    ShowModalExport() {
      product_service.GetExportProduct()
    },
    DeleteProduct(id) {
      swal("¿Seguro que va eliminar el producto?", {
        buttons: {
          cancel: "Cancelar",
          Aceptar: true,
        },
      })
          .then((value) => {
            switch (value) {
              case "Aceptar":
                product_service.DeleteProduct(id)
                break;
            }
          });

    },
    ShowModalImportar() {

    }
  },
  created() {
    (TEST_ENVIRONMENT) ? this.constans = CONSTANTS_TEST : this.constans = CONSTANTS_PROD;
    this.full_url_img = this.constans.IMG_PATH;
    this.full_url_img2 = this.constans.IMG_PATH2;
    bus.$on('GetAllProduct', (response, value) => {
      if (response.length >= 1) {
        this.products = response
        this.page_count = Math.ceil(value / 10)
        this.value = 1
      } else {
        this.products = []
      }
    })
    bus.$on('GetAllProductPagination', (response) => {
      this.products = response
    })
    bus.$on('GetExportProduct', (response) => {
      if (response.data.error === false) {
        window.open(this.full_url_img2 + response.data.exportrl)
      }
    })
    bus.$on('ResponseDeleteProduct', (response) => {
      if (response === '500') {
        swal({
          dangerMode: true,
          icon: "error",
          text: "No Se Elimino El Producto Porque Tiene Movimientos Asociados.",
          button: "Aceptar"
        })
      }
      if (response) {

        swal({
          icon: "success",
          text: "Se Ha Eliminado El Producto Con Exito",
          button: "Aceptar"
        })
        setTimeout(function() {
          location.reload();
        }, 2000);
      }
    })

  }
}
</script>


<style scoped>
.img-produt {
  width: 100%;
}
</style>